import { createFileRoute } from "@tanstack/react-router"

import { CniLicenseDetailView } from "@/features/cni-licenses/components/CniLicenseDetailView"

export const Route = createFileRoute("/_authed/cni/licenses/$id")({
  component: CniLicenseDetailPage,
})

function CniLicenseDetailPage() {
  const { id } = Route.useParams()
  return <CniLicenseDetailView id={id} />
}
